import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.auth.isAuthenticated$.pipe(
      map((isAuthenticated) => {
        if (isAuthenticated) {
          this.router.navigate(['/dashboard']);
          return !isAuthenticated;
        }
        return !isAuthenticated;
      })
    );
  }
}
